<soft-ds-select size="lg"
                leadingIcon="fa-regular fa-bookmark"
                dividers
                [panelMaxWidth]="panelMaxWidth()"
                (opened)="onOpened()"
                [placeholder]="title()"
                [items]="items()"
                [value]="activeId()"
                (valueChange)="applyTemplate($event)"
                [listboxFooter]="footer"
                data-testid="filter-menu-bar-templates" />

<ng-template #footer>
  <div class="filter-templates-footer">
    <soft-ds-button variant="ghost" size="lg"
                    (click)="openTemplateManagement()"
                    data-testid="filter-menu-bar-manage-templates">
      {{ '#CORE_FILTER.TEMPLATES.MANAGE' | translate }}
    </soft-ds-button>
  </div>
</ng-template>
